import api from "../../composables/app";
import { API } from "../apis";

export const getProductList = () => {
  return api.get(`${API.payment.productList}/`);
};
